<style lang="scss" scoped></style>
<template>
  <div class="">
    <div class="pt-12 sm:pt-16 lg:pt-24">
      <div class="max-w-screen-xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto lg:max-w-none">
          <h2 class="text-lg leading-6 font-semibold text-gray-900 uppercase tracking-wider">
            Pricing
          </h2>
          <p
            class="mt-2 text-3xl leading-9 font-extrabold text-gray-700 sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none">
            Affordable and simple pricing
          </p>
        </div>
      </div>
    </div>
    <div class="mt-8 pb-12  sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
      <div class="relative">
        <div class="relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="max-w-md mx-auto lg:max-w-5xl lg:grid lg:grid-cols-3 lg:gap-5">
            <div class="rounded-lg shadow-lg overflow-hidden">
              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-standard">
                    Free
                  </h3>
                </div>
                <div class="mt-4 flex items-baseline text-6xl leading-none font-extrabold">
                  $0
                  <span class="ml-1 text-2xl leading-8 font-medium text-gray-500">
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      100 Manual WhatsApp messages.
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp share button
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp Chat button
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Reports
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Unlimited message templates
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Standard support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button href="#"
                    class=" block w-full text-center rounded-lg bg-white px-6 py-3 text-base leading-6 font-semibold font-display text-teal-600 hover:text-teal-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                    aria-describedby="tier-standard" @click="choosePlan('free')">
                    <span v-if="store.plan === 'pro' ||
                      store.plan === 'vip' ||
                      store.plan === 'advanced'
                      ">Contact us</span>
                    <span v-if="store.plan === 'free'">Current Plan</span>
                    <span v-if="store.plan === 'limited_free'">Current Plan</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-4   lg:mt-0 relative z-10 rounded-lg shadow-xl">
              <div class="pointer-events-none absolute inset-0 rounded-lg "></div>

              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-enterprise">
                    VIP
                  </h3>
                </div>
                <div class="mt-4 flex items-baseline text-6xl leading-none font-extrabold">
                  $9.99
                  <span class="ml-1 text-2xl leading-8 font-medium text-gray-500">
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Free +
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Unlimited Manual Messages
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automated messages
                      <a class="text-blue-400 text-sm"
                        href="https://docs.google.com/spreadsheets/d/1Bc8J7Majk2spWA7S8Lf6VV-0mGF11nYpKKedrv44hyc/edit?usp=sharing"
                        target="blank">(Price per message)</a>
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp CRM
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Email alerts
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Loox Integration
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Priority support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button href="#"
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75"
                    aria-describedby="tier-enterprise" @click="choosePlan('vip')" :disabled="store.plan === 'vip'">
                    <span v-if="store.plan === 'limited_free' || store.plan === 'free'
                      ">{{ getTrialButtonContent('vip') }}</span>
                    <span v-if="store.plan === 'advanced'">Downgrade</span>
                    <span v-if="store.plan === 'vip'">Current Plan</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="mt-4   lg:mt-0 relative z-10 rounded-lg shadow-xl">
              <div class="pointer-events-none absolute inset-0 rounded-lg border-2 border-teal-400 "></div>
              <div class="absolute inset-x-0 top-0 transform translate-y-px">
                <div class="flex justify-center transform -translate-y-1/2">
                  <span
                    class="inline-flex rounded-full bg-teal-400 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white">
                    Recommended
                  </span>
                </div>
              </div>
              <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg">
                <div>
                  <h3
                    class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600"
                    id="tier-enterprise">
                    Advanced
                  </h3>
                </div>
                <div class="mt-4 flex items-baseline text-6xl leading-none font-extrabold">
                  $29
                  <span class="ml-1 text-2xl leading-8 font-medium text-gray-500">
                    /mo
                  </span>
                </div>
              </div>
              <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                <ul>
                  <li class="flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Free +
                    </p>
                  </li>
                  <!-- <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg
                        class="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp broadcast
                    </p>
                  </li> -->
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Unlimited Manual Messages
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automated messages
                      <a class="text-blue-400 text-sm"
                        href="https://docs.google.com/spreadsheets/d/1Bc8J7Majk2spWA7S8Lf6VV-0mGF11nYpKKedrv44hyc/edit?usp=sharing"
                        target="blank">(Price per message)</a>
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Automation on own number
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Custom automated templates
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Whatsapp CRM
                    </p>
                  </li>

                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Team inbox
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      1000 Session messages included
                    </p>
                  </li>
                  <li class="mt-4 flex items-start">
                    <div class="flex-shrink-0">
                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p class="ml-3 text-base leading-6 text-gray-700">
                      Priority support
                    </p>
                  </li>
                </ul>
                <div class="mt-6 rounded-md shadow">
                  <button href="#"
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75"
                    aria-describedby="tier-enterprise" @click="choosePlan('advanced')"
                    :disabled="store.plan === 'advanced'">
                    <span v-if="store.plan !== 'advanced'">{{ getTrialButtonContent('advanced') }}</span>
                    <span v-else>Current Plan</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Header">
            <h2 class="Polaris-Text--root Polaris-Text--headingLg">
              Frequently asked questions
            </h2>
          </div>
          <div class="Polaris-LegacyCard__Section">
            <AccordianItem v-for="(faq, index) of faqs" :key="index" :title="faq.title" :content="faq.content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordianItem from "../components/Common/AccordianItem";

export default {
  name: "Plan",
  components: {
    AccordianItem
  },
  data() {
    return {
      faqs: [
        {
          title: "Will I be charged for failed messages?",
          content:
            "No, if that’s not a WhatsApp number or if we couldn’t deliver a message we wouldn’t count that message."
        },
        {
          title: "Will the automated messages go from my number?",
          content:
            "Yes with our advanced plan, Your automated messages will be sent from your number and you can also reply to the messages you receive in that number. On Vip Plan messages will be sent from our business number"
        },
        {
          title: "Can I send WhatsApp messages to everybody?",
          content:
            "You can only send it to people who have opted in via checkout."
        },
        {
          title: "What are session messages?",
          content:
            "WhatsApp Session messages are any messages sent and received in response to a user-initiated message to number. A messaging session starts when a user sends your application a message and lasts for 24 hours from the most recently received message."
        },
        {
          title: "What If I want to send a message after 24 Hours?",
          content:
            "You could either wait for the customer to send a message or You could send a template message to initiate the conversation again."
        },
        {
          title: "How will I get Charged?",
          content:
            "Our Advanced plan includes 1000 session messages(incoming & outgoing), Once you have reached the limit we will charge $10 for the next 5000 messages"
        }
      ]
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    }
  },
  async created() {
    await this.$store.dispatch("getConfig");
  },
  methods: {
    isNotShopifyStaff(planName) {
      return ["custom", "staff", "staff_business"].indexOf(planName) === -1;
    },
    choosePlan(plan) {
      const shopifyPlan = this.$store.getters.getShopifyPlan;

      if (
        plan === "free" &&
        this.isNotShopifyStaff(shopifyPlan) &&
        (this.store.plan === "vip" || this.store.plan === "advanced")
      ) {
        this.openMailer();
        return;
      }

      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then(response => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Home" });
          }
        });
    },
    openMailer() {
      window.open("mailto:help@carthike.com?subject=plan downgrade", "_blank");
    },
    getTrialButtonContent(plan) {
      const trialDetails = this.$store.getters.getTrailDetails;
      if (trialDetails && trialDetails[plan]) {
        return "Upgrade"
      }
      return "Start 7 day Trial"
    }
  }
};
</script>

<style lang="scss" scoped></style>
